import React from 'react';
import classes from './styles.module.css';

export default function EmptyBag() {
  return (
    <div className={classes.emptyBox}>
      <div className={classes.emptyImage}></div>
      <span className={classes.emptyTitle}>Sua sacola ainda está vazia</span>
      <span className={classes.emptyDescription}>Adicione itens do cardápio para realizar um pedido</span>
    </div>
  );
}
